import { Person, usePeopleService } from 'nekst-api';
import { useDataLoaderNew } from 'data-loader';
import React from 'react';
import { CalendarLinksBlockLayout } from './Layout';

interface CalendarLinksBlockProps {
  person: Person;
}

export function CalendarLinksBlock(props: CalendarLinksBlockProps) {
  const peopleService = usePeopleService();

  const linksLoader = useDataLoaderNew(
    () => peopleService.getICalLinks(props.person.id),
    {
      dependencies: [props.person.id],
    }
  );

  return (
    <CalendarLinksBlockLayout
      isLoading={linksLoader.loading}
      data={linksLoader.data}
    />
  );
}
